<div class="flex map flex column align-center radius-3 mt-5 brd brd-200">
  <div class="title flex align-center" [ngClass]="{'location-title': !title}">
    <p class="weight-medium h6 m-0 text-900" *ngIf="!title">{{'Location.Locations' | translate}}</p>
    <p class="weight-medium h6 m-0 text-900" *ngIf="title">{{ title }}</p>
  </div>

  <div class="map-area">
    <div class="map-canvas" *ngIf="googleMapLoaded">
      <google-map [center]="{lat: +latitude, lng: +longitude }" [zoom]="zoom" [options]="{ scrollwheel: false }">
        <ng-container *ngIf="locations?.length">
          <app-map-overlay [latitude]="+location.latitude" [longitude]="+location.longitude" *ngFor="let location of locations">
            <div class="overlay">
              <div class="image" [class.active]="location.selected">
                <app-icon *ngIf="!location.selected" [name]="'map-marker-icon'"></app-icon>
                <app-icon *ngIf="location.selected" [name]="'map-marker-active-icon'"></app-icon>
              </div>
              <div *ngIf="location.selected" class="indicator"></div>
              <div *ngIf="location.selected" class="data flex column">
                <div class="title flex">
                  <img *ngIf="location.isDefault" src="assets/images/primary-icon.svg" />
                  <h3>{{location.title}}</h3>
                </div>
                <div class="city flex">
                  <span>{{'Location.Labels.City' | translate}}</span>
                  <p>{{location.city?.name}}</p>
                </div>
                <div class="location flex">
                  <span>{{'Location.Labels.Location' | translate}}</span>
                  <p>{{location.latitude + ', ' + location.longitude}}</p>
                </div>
                <div class="address flex">
                  <span>{{'Location.Labels.Address' | translate}}</span>
                  <p>{{location.address}}</p>
                </div>
              </div>
            </div>
          </app-map-overlay>
        </ng-container>
      </google-map>
    </div>

    <div class="locations flex column" *ngIf="enableLocationsView">
      <div
        class="location flex column"
        [class.active]="location.selected"
        *ngFor="let location of locations"
        (click)="onSelectLocation(location)"
      >
        <div class="title flex align-center justify-space-between">
          <div class="flex align-center">
            <img *ngIf="location.isDefault" src="assets/images/primary-icon.svg" />
            <!-- The card itself cannot carry `role="button"`: it also contains the actions menu,
                 and a button may not wrap other interactive content. The title is the real
                 control, so it is the thing that takes focus and reports the selected state. -->
            <h3 [matTooltip]="location.title">
              <button
                type="button"
                class="location-select"
                [attr.aria-pressed]="!!location.selected"
                (click)="$event.stopPropagation(); onSelectLocation(location)"
              >{{location.title}}</button>
            </h3>
          </div>
          <div class="menu flex">
            <button
              type="button"
              class="menu-trigger"
              [matMenuTriggerFor]="menu"
              [attr.aria-label]="'Location.Actions' | translate"
              (click)="$event.stopPropagation()"
            >
              <app-icon name="menu-vert" class="text-700"></app-icon>
            </button>
            <mat-menu class="item-actions" #menu>
              <button mat-menu-item (click)="onSetAsDefault(location)">
                <span>{{ "Location.SetAsDefault" | translate }}</span>
              </button>
              <button mat-menu-item (click)="onSelectLocation(location); matDialog.open(addLocationModal)">
                <span>{{ "Buttons.Edit" | translate }}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="city flex column">
          <span>{{'Location.Labels.City' | translate}}</span>
          <p>{{location.city?.name}}</p>
        </div>
        <div class="lat flex column">
          <span>{{'Location.Labels.Location' | translate}}</span>
          <p>{{location.latitude + ',' + location.longitude}}</p>
        </div>
        <div class="address flex column">
          <span>{{'Location.Labels.Address' | translate}}</span>
          <p>{{location.address}}</p>
        </div>
      </div>
      <button *ngIf="!generalReceiver" type="button" class="button flex align-center justify-center" (click)="selectedLocation = {}; matDialog.open(addLocationModal)">
        <img src="assets/images/add-icon.svg" />
        <span *ngIf="locations?.length">{{'Location.AddMoreLocations' | translate}}</span>
        <span *ngIf="!locations?.length">{{'Location.AddLocation' | translate}}</span>
      </button>
    </div>
  </div>
</div>

<ng-template #addLocationModal>
  <app-dialog-layout class="dialog-layout madar--v2">
    <ng-container dialog-title>{{ (selectedLocation?.id ? 'Location.EditLocation' : 'Location.AddLocation') | translate }}</ng-container>
    <div dialog-content class="mt-3">
        <app-add-location
        (closeModal)="matDialog.closeAll()"
        (updatedLocation)="onUpdateLocation($event)"
        (locationId)="onAddLocation($event)"
        [item]="item"
        [location]="selectedLocation"
        [type]="type"
        ></app-add-location>
    </div>
  </app-dialog-layout>
</ng-template>
